import { SEO } from "../../../seo/keywords";

export default function IntroCore() {
    return (
        <div className="flex flex-col w-full h-full items-center justify-center py-[5rem]">
            <div className="flex flex-col xl:flex-row justify-center items-center w-[80%] xl:w-[70%] h-full gap-y-[2rem] xl:gap-y-[0rem]">

                <div className="flex flex-col w-full xl:w-[50%] justify-center items-center gap-y-[1.5rem]">
                    <img
                        src="/images/product/intro_logo.webp"
                        alt="Takamori Robot engineering kit for education robotics"
                        className="xl:w-[50%] max-w-l h-auto"
                        loading="lazy"
                    />
                    <p className="text-[25px]">
                        Robots Are Fun and Exploration is Play
                    </p>
                </div>

                <div className="flex flex-col w-full xl:w-[50%] gap-y-[2rem]">
                    <div className="flex flex-col gap-y-[1rem]">
                        <h2 id="mission-goal" className="text-4xl">
                            OUR <span className="text-[#2FC1E2]">MISSION</span>
                        </h2>
                        <p>
                            At Takamori Robot, our mission is to make robotics education more accessible with an{" "}
                            <strong>{SEO.primary}</strong> that bridges learning and real-world application.
                        </p>
                    </div>
                    <div className="flex flex-col gap-y-[1rem]">
                        <h3 className="text-4xl">
                            OUR <span className="text-[#2FC1E2]">GOAL</span>
                        </h3>
                        <p>
                            We aim to empower students, educators, and makers with hands-on tools that inspire exploration, foster creativity, and build a strong foundation in robotics and engineering.
                        </p> 
                    </div>
                </div>
            </div>
        </div>
    );
}